"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.update = exports.create = exports.findOne = exports.findAllEventoEdicaoAtivasPublica = exports.findAllEventoEdicaoAtivas = exports.findAll = void 0;
const core_1 = require("./core");
const search_1 = require("./search");
function findAll(page = 1, search) {
    const encodedSearch = search_1.encodeSearchValues(search);
    return core_1.get('EventoEdicao', 'lista', Object.assign({ pg: page }, encodedSearch))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.findAll = findAll;
function findAllEventoEdicaoAtivas(page = 1, search) {
    const encodedSearch = search_1.encodeSearchValues(search);
    return core_1.get('EventoEdicao', 'listaEventoEdicaoAtiva', Object.assign({ pg: page }, encodedSearch))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.findAllEventoEdicaoAtivas = findAllEventoEdicaoAtivas;
function findAllEventoEdicaoAtivasPublica(page = 1, idComp, search) {
    const encodedSearch = search_1.encodeSearchValues(search);
    return core_1.get('EventoEdicao', 'listaEventoEdicaoAtivaPublica', Object.assign({ pg: page, id: idComp }, encodedSearch))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.findAllEventoEdicaoAtivasPublica = findAllEventoEdicaoAtivasPublica;
function findOne(id) {
    return core_1.get('EventoEdicao', 'detalhe', { id });
}
exports.findOne = findOne;
function create(data) {
    return core_1.post('EventoEdicao', 'cadastro', data);
}
exports.create = create;
function update(id, data) {
    return core_1.post('EventoEdicao', 'update', Object.assign({ id }, data));
}
exports.update = update;
function remove(id) {
    return core_1.del('EventoEdicao', 'exclui', { id });
}
exports.remove = remove;
